import { useState, } from 'react';
import Swal from 'sweetalert2';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import styles from './Register.module.css';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2'; 
import 'react-phone-input-2/lib/style.css';
import MensajeVerificacion from './MensajeVerificacion';

const Register = () => {
    const navigate = useNavigate();
    const [mostrarVerificacion, setMostrarVerificacion] = useState(false); 
    const [ correoVerificacion, setCorreoVerificacion] = useState(''); 
    const [nombre, setNombre] = useState('');
    const [appa, setAppa] = useState('');
    const [apma, setApma] = useState('');
    const [correo, setCorreo] = useState('');
    const [contrasenia, setContrasenia] = useState('');
    const [confcontrasenia, setConfContrasenia] = useState('');
    const [curp, setCurp] = useState('');
    const [fecha_nacimiento, setFechaNacimiento] = useState('');
    const [estado, setEstado] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [bachillerato, setBachillerato] = useState('');
    const [matricula, setMatricula] = useState('');
    const [institucion, setInstitucion] = useState('');
    const [telefono, setTelefono] = useState('');
    const [correo_tutor, setCorreoTutor] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [errores, setErrores] = useState({
        contrasenia: '', 
        curp: '',
        telefono: '', 
        correo: '',
        correo_tutor: '', 
    });
    const [seleccionEstud, setSeleccionEstud] = useState('');

    const estados = [
        { value: "Aguascalientes", label: "Aguascalientes" },
        { value: "Baja California", label: "Baja California" },
        { value: "Baja California Sur", label: "Baja California Sur" },
        { value: "Campeche", label: "Campeche" },
        { value: "Chiapas", label: "Chiapas" },
        { value: "Chihuahua", label: "Chihuahua" },
        { value: "Ciudad de México", label: "Ciudad de México" },
        { value: "Coahuila", label: "Coahuila" },
        { value: "Colima", label: "Colima" },
        { value: "Durango", label: "Durango" },
        { value: "Estado de México", label: "Estado de México" },
        { value: "Guanajuato", label: "Guanajuato" },
        { value: "Guerrero", label: "Guerrero" },
        { value: "Hidalgo", label: "Hidalgo" },
        { value: "Jalisco", label: "Jalisco" },
        { value: "Michoacán", label: "Michoacán" },
        { value: "Morelos", label: "Morelos" },
        { value: "Nayarit", label: "Nayarit" },
        { value: "Nuevo León", label: "Nuevo León" },
        { value: "Oaxaca", label: "Oaxaca" },
        { value: "Puebla", label: "Puebla" },
        { value: "Quintana Roo", label: "Quintana Roo" },
        { value: "San Luis Potosí", label: "San Luis Potosí" },
        { value: "Sinaloa", label: "Sinaloa" },
        { value: "Sonora", label: "Sonora" },
        { value: "Tabasco", label: "Tabasco" },
        { value: "Tamaulipas", label: "Tamaulipas" },
        { value: "Tlaxcala", label: "Tlaxcala" },
        { value: "Veracruz", label: "Veracruz" },
        { value: "Yucatán", label: "Yucatán" },
        { value: "Zacatecas", label: "Zacatecas" },
    ];

    const municipios = [
        { value: "Amealco de Bonfil", label: "Amealco de Bonfil" },
        { value: "Arroyo Seco", label: "Arroyo Seco" },
        { value: "Cadereyta de Montes", label: "Cadereyta de Montes" },
        { value: "Colón", label: "Colón" },
        { value: "Corregidora", label: "Corregidora" },
        { value: "El Marqués", label: "El Marqués" },
        { value: "Ezequiel Montes", label: "Ezequiel Montes" },
        { value: "Huimilpan", label: "Huimilpan" },
        { value: "Jalpan de Serra", label: "Jalpan de Serra" },
        { value: "Landa de Matamoros", label: "Landa de Matamoros" },
        { value: "Pedro Escobedo", label: "Pedro Escobedo" },
        { value: "Peñamiller", label: "Peñamiller" },
        { value: "Pinal de Amoles", label: "Pinal de Amoles" },
        { value: "Querétaro", label: "Querétaro" },
        { value: "San Joaquín", label: "San Joaquín" },
        { value: "San Juan del Río", label: "San Juan del Río" },
        { value: "Tequisquiapan", label: "Tequisquiapan" },
        { value: "Tolimán", label: "Tolimán" },
    ];

    const bachilleratos = [
        { value: "Academia Casa Hogar Sor Juana Inés De La Cruz A.C.", dataMunicipio: "Querétaro", label: "Academia Casa Hogar Sor Juana Inés De La Cruz A.C." },
        { value: "Alma Muriel", dataMunicipio: "Querétaro", label: "Alma Muriel" },
        { value: "Bachillerato Carl Rogers", dataMunicipio: "Corregidora", label: "Bachillerato Carl Rogers" },
        { value: "Bachillerato Colegio México Nuevo Campus Querétaro", dataMunicipio: "Querétaro", label: "Bachillerato Colegio México Nuevo Campus Querétaro" },
        { value: "Bachillerato de la Universidad de las Mujeres", dataMunicipio: "Querétaro", label: "Bachillerato de la Universidad de las Mujeres" },
        { value: "Bachillerato de la Universidad del Valle de México Querétaro", dataMunicipio: "Querétaro", label: "Bachillerato de la Universidad del Valle de México Querétaro" },
        { value: "Bachillerato Nuevo Continente Campus Querétaro", dataMunicipio: "Querétaro", label: "Bachillerato Nuevo Continente Campus Querétaro" },
        { value: "Bachillerato Omi San Juan del Río", dataMunicipio: "San Juan del Río", label: "Bachillerato Omi San Juan del Río" },
        { value: "Bachillerato Tecnológico de la Universidad Internacional de Querétaro", dataMunicipio: "Querétaro", label: "Bachillerato Tecnológico de la Universidad Internacional de Querétaro" },
        { value: "Bachillerato Tecnológico del Instituto de Estudios Turísticos del Centro", dataMunicipio: "Querétaro", label: "Bachillerato Tecnológico del Instituto de Estudios Turísticos del Centro" },

        {
            value: "Bachillerato Tecnológico del Instituto Juárez Lincoln"
            , dataMunicipio: "Querétaro", label: "Bachillerato Tecnológico del Instituto Juárez Lincoln"
        },
        {
            value: "Bachillerato Tecnológico del Instituto Uni de Querétaro"
            , dataMunicipio: "Querétaro", label: "Bachillerato Tecnológico del Instituto Uni de Querétaro"
        },
        {
            value: "Bachillerato Tecnológico Grupo Isima, Plantel Querétaro"
            , dataMunicipio: "Querétaro", label: "Bachillerato Tecnológico Grupo Isima, Plantel Querétaro"
        },
        {
            value: "Bachillerato Tecnológico Instituto Vasco Plantel Querétaro"
            , dataMunicipio: "Querétaro", label: "Bachillerato Tecnológico Instituto Vasco Plantel Querétaro"
        },
        { value: "Bachillerato UGM Querétaro", dataMunicipio: "Corregidora", label: "Bachillerato UGM Querétaro" },
        { value: "Bachillerato UNEA Campus Querétaro", dataMunicipio: "Querétaro", label: "Bachillerato UNEA Campus Querétaro" },
        { value: "Buckingham High School", dataMunicipio: "Corregidora", label: "Buckingham High School" },
        { value: "CAED CECATI 17", dataMunicipio: "Querétaro", label: "CAED CECATI 17" },
        { value: "CAED CECATI 175", dataMunicipio: "Querétaro", label: "CAED CECATI 175" },
        { value: "CAED Querétaro", dataMunicipio: "Querétaro", label: "CAED Querétaro" },

        { value: "CAED San Juan del Río", dataMunicipio: "San Juan del Río", label: "CAED San Juan del Río" },
        { value: "CEDART Ignacio Mariano de las Casas", dataMunicipio: "Querétaro", label: "CEDART Ignacio Mariano de las Casas" },
        { value: "CEDVA Preparatoria", dataMunicipio: "Querétaro", label: "CEDVA Preparatoria" },
        { value: "Centro Cultural Fray Junípero Serra", dataMunicipio: "Querétaro", label: "Centro Cultural Fray Junípero Serra" },
        {
            value: "Centro de Atención para Estudiantes con Discapacidad, CECATI 122"
            , dataMunicipio: "Tequisquiapan", label: "Centro de Atención para Estudiantes con Discapacidad, CECATI 122"
        },
        { value: "Centro de Bachillerato Tecnológico Agropecuario No. 326, en El Cazadero, Querétaro", dataMunicipio: "Querétaro", label: "Centro de Bachillerato Tecnológico Agropecuario No. 326, en ElCazadero, Querétaro" },
        {
            value: "Centro de Bachillerato Tecnológico Agropecuario Num. 115"
            , dataMunicipio: "Colón", label: "Centro de Bachillerato Tecnológico Agropecuario Num. 115"
        },
        {
            value: "Centro de Bachillerato Tecnológico Agropecuario Num. 256"
            , dataMunicipio: "Pedro Escobedo", label: "Centro de Bachillerato Tecnológico Agropecuario Num. 256"
        },
        {
            value: "Centro de Bachillerato Tecnológico Industrial y de Servicios Num. 118"
            , dataMunicipio: "Corregidora", label: "Centro de Bachillerato Tecnológico Industrial y de Servicios Num. 118"
        },
        {
            value: "Centro de Bachillerato Tecnológico Industrial y de Servicios Num. 145"
            , dataMunicipio: "Querétaro", label: "Centro de Bachillerato Tecnológico Industrial y de Servicios Num. 145"
        },

        { value: "Centro de Educación y Formación Jamadi", dataMunicipio: "Querétaro", label: "Centro de Educación y Formación Jamadi" },
        { value: "Centro de Estudios de Bachillerato John Von Newman", dataMunicipio: "Querétaro", label: "Centro de Estudios de Bachillerato John Von Newman" },
        { value: "Centro de Estudios Medio Superiores y Superiores", dataMunicipio: "Querétaro", label: "Centro de Estudios Medio Superiores y Superiores" },
        {
            value: "Centro de Estudios Tecnológicos en Aguas Continentales No. 23 en El Marqués, Qro."
            , dataMunicipio: "El Marqués", label: "Centro de Estudios Tecnológicos en Aguas Continentales No. 23 en El Marqués, Qro."
        },
        {
            value: "Centro de Estudios Tecnológicos en Aguas Continentales No. 24 en Corregidora, Qro."
            , dataMunicipio: "Corregidora", label: "Centro de Estudios Tecnológicos en Aguas Continentales No. 24 en Corregidora, Qro."
        },
        {
            value: "Centro de Estudios Tecnológicos Industrial y de Servicios Num. 16"
            , dataMunicipio: "Querétaro", label: "Centro de Estudios Tecnológicos Industrial y de Servicios Num. 16"
        },
        {
            value: "Centro de Estudios Tecnológicos Industrial y de Servicios Num. 105"
            , dataMunicipio: "Querétaro", label: "Centro de Estudios Tecnológicos Industrial y de Servicios Num. 105"
        },
        {
            value: "Centro de Estudios Tecnológicos Industrial y de Servicios Num. 142"
            , dataMunicipio: "Tequisquiapan", label: "Centro de Estudios Tecnológicos Industrial y de Servicios Num. 142"
        },

        { value: "Centro de Estudios Universitarios en Querétaro", dataMunicipio: "Querétaro", label: "Centro de Estudios Universitarios en Querétaro" },
        {
            value: "Centro de Formación de Recursos de Enfermería de Querétaro, A.C."
            , dataMunicipio: "Querétaro", label: "Centro de Formación de Recursos de Enfermería de Querétaro, A.C."
        },

        { value: "Centro de Innovación Educativa México", dataMunicipio: "Querétaro", label: "Centro de Innovación Educativa México" },
        {
            value: "Centro Interactivo de Educación y Alta Especialización CIEE"
            , dataMunicipio: "Querétaro", label: "Centro Interactivo de Educación y Alta Especialización CIEE"
        },
        { value: "Centro Unión", dataMunicipio: "Querétaro", label: "Centro Unión" },
        { value: "Centro Universitario de Educación Contemporánea", dataMunicipio: "Querétaro", label: "Centro Universitario de Educación Contemporánea" },
        {
            value: "Centro Universitario Salvador Vázquez Altamirano, A.C."
            , dataMunicipio: "Querétaro", label: "Centro Universitario Salvador Vázquez Altamirano, A.C."
        },
        { value: "Cinco de Mayo", dataMunicipio: "Querétaro", label: "Cinco de Mayo" },
        { value: "Clara Barton", dataMunicipio: "Querétaro", label: "Clara Barton" },
        { value: "Clemencia Borja Taboada", dataMunicipio: "Querétaro", label: "Clemencia Borja Taboada" },
        { value: "COBAQ Bachillerato Mixto", dataMunicipio: "Querétaro", label: "COBAQ Bachillerato Mixto" },
        { value: "COBAQ Plantel Num. 1 Satélite", dataMunicipio: "Querétaro", label: "COBAQ Plantel Num. 1 Satélite" },
        { value: "COBAQ Plantel Num. 2 Amealco", dataMunicipio: "Amealco de Bonfil", label: "COBAQ Plantel Num. 2 Amealco" },
        { value: "COBAQ Plantel Num. 3 Corregidora", dataMunicipio: "Corregidora", label: "COBAQ Plantel Num. 3 Corregidora" },
        { value: "COBAQ Plantel Num. 4 Jalpan", dataMunicipio: "Jalpan de Serra", label: "COBAQ Plantel Num. 4 Jalpan" },
        { value: "COBAQ Plantel Num. 5 Cadereyta", dataMunicipio: "Cadereyta de Montes", label: "COBAQ Plantel Num. 5 Cadereyta" },
        { value: "COBAQ Plantel Num. 6 Tolimán", dataMunicipio: "Tolimán", label: "COBAQ Plantel Num. 6 Tolimán" },
        { value: "COBAQ Plantel Num. 7 El Marqués", dataMunicipio: "El Marqués", label: "COBAQ Plantel Num. 7 El Marqués" },
        { value: "COBAQ Plantel Num. 8 Azteca", dataMunicipio: "Querétaro", label: "COBAQ Plantel Num. 8 Azteca" },
        { value: "COBAQ Plantel Num. 9 Santa Rosa Jáuregui", dataMunicipio: "Querétaro", label: "COBAQ Plantel Num. 9 Santa Rosa Jáuregui" },
        { value: "COBAQ Plantel Num. 10 San Juan del Río", dataMunicipio: "San Juan del Río", label: "COBAQ Plantel Num. 10 San Juan del Río" },
        { value: "COBAQ Plantel Num. 11 Ezequiel Montes", dataMunicipio: "Ezequiel Montes", label: "COBAQ Plantel Num. 11 Ezequiel Montes" },
        { value: "COBAQ Plantel Num. 12 Tequisquiapan", dataMunicipio: "Tequisquiapan", label: "COBAQ Plantel Num. 12 Tequisquiapan" },
        { value: "COBAQ Plantel Num. 13 Epigmenio González", dataMunicipio: "Querétaro", label: "COBAQ Plantel Num. 13 Epigmenio González" },
        { value: "COBAQ Plantel Num. 14 San Joaquín", dataMunicipio: "San Joaquín", label: "COBAQ Plantel Num. 14 San Joaquín" },
        { value: "COBAQ Plantel Num. 15 Chichimequillas", dataMunicipio: "El Marqués", label: "COBAQ Plantel Num. 15 Chichimequillas" },
        { value: "COBAQ Plantel Num. 16 El Colorado", dataMunicipio: "El Marqués", label: "COBAQ Plantel Num. 16 El Colorado" },
        { value: "COBAQ Plantel Num. 17 'Constitución de 1917'", dataMunicipio: "Querétaro", label: "COBAQ Plantel Num. 17 'Constitución de 1917'" },
        { value: "COBAQ Plantel Num. 18 Valle Dorado", dataMunicipio: "Querétaro", label: "COBAQ Plantel Num. 18 Valle Dorado" },
        { value: "COBAQ Plantel Num. 19 Bravo", dataMunicipio: "Corregidora", label: "COBAQ Plantel Num. 19 Bravo" },
        { value: "COBAQ Plantel Num. 20 Santiago Mexquititlán", dataMunicipio: "Amealco de Bonfil", label: "COBAQ Plantel Num. 20 Santiago Mexquititlán" },
        { value: "COBAQ Plantel Num. 21 Arcila", dataMunicipio: "Querétaro", label: "COBAQ Plantel Num. 21 Arcila" },
        { value: "COBAQ Plantel Num. 22 Real de San Miguel", dataMunicipio: "Querétaro", label: "COBAQ Plantel Num. 22 Real de San Miguel" },
        { value: "COBAQ Plantel Num. 23 Ahuacatlán de Guadalupe", dataMunicipio: "Pinal de Amoles", label: "COBAQ Plantel Num. 23 Ahuacatlán de Guadalupe" },
        { value: "COBAQ Plantel Num. 24 Villa Progreso", dataMunicipio: "Ezequiel Montes", label: "COBAQ Plantel Num. 24 Villa Progreso" },
        { value: "COBAQ Plantel Num. 25 La Lagunita", dataMunicipio: "Landa de Matamoros", label: "COBAQ Plantel Num. 25 La Lagunita" },
        { value: "COBAQ Plantel Num. 26 Agua Zarca", dataMunicipio: "Landa de Matamoros", label: "COBAQ Plantel Num. 26 Agua Zarca" },
        { value: "COBAQ Plantel Num. 27 Purísima de Arista", dataMunicipio: "Arroyo Seco", label: "COBAQ Plantel Num. 27 Purísima de Arista" },
        { value: "COBAQ Plantel Num. 28 San Ildefonso", dataMunicipio: "Amealco de Bonfil", label: "COBAQ Plantel Num. 28 San Ildefonso" },
        { value: "COBAQ Plantel Num. 29 Bernal", dataMunicipio: "Ezequiel Montes", label: "COBAQ Plantel Num. 29 Bernal" },
        { value: "COBAQ Plantel Num. 30 La Valla", dataMunicipio: "Querétaro", label: "COBAQ Plantel Num. 30 La Valla" },
        { value: "COBAQ Plantel Num. 31 La Griega", dataMunicipio: "El Marqués", label: "COBAQ Plantel Num. 31 La Griega" },
        { value: "COBAQ Plantel Num. 32 San Antonio de la Cal", dataMunicipio: "Tolimán", label: "COBAQ Plantel Num. 32 San Antonio de la Cal" },
        { value: "COBAQ Plantel Num. 33 El Palmar", dataMunicipio: "Cadereyta de Montes", label: "COBAQ Plantel Num. 33 El Palmar" },
        { value: "COBAQ Plantel Num. 34 Arroyo Seco", dataMunicipio: "Arroyo Seco", label: "COBAQ Plantel Num. 34 Arroyo Seco" },
        { value: "COBAQ Plantel Num. 35 Vizarrón", dataMunicipio: "Cadereyta de Montes", label: "COBAQ Plantel Num. 35 Vizarrón" },
        { value: "Colegio Álamos", dataMunicipio: "Querétaro", label: "Colegio Álamos" },
        { value: "Colegio Austriaco Mexicano Preparatoria", dataMunicipio: "Querétaro", label: "Colegio Austriaco Mexicano Preparatoria" },
        { value: "Colegio Bosques Preparatoria Campus Real", dataMunicipio: "Querétaro", label: "Colegio Bosques Preparatoria Campus Real" },
        { value: "Colegio Carol Baur", dataMunicipio: "Querétaro", label: "Colegio Carol Baur" },
        { value: "Colegio Castellano Preparatoria", dataMunicipio: "Corregidora", label: "Colegio Castellano Preparatoria" },
        { value: "Colegio Celta Internacional", dataMunicipio: "Corregidora", label: "Colegio Celta Internacional" },

        { value: "Colegio Cervantes", dataMunicipio: "Querétaro", label: "Colegio Cervantes" },
        { value: "Colegio de Ciencias y Humanidades de Querétaro", dataMunicipio: "Querétaro", label: "Colegio de Ciencias y Humanidades de Querétaro" },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 10 Plantel La Esperanza"
            , dataMunicipio: "Colón", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 10 Plantel La Esperanza"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 11 Plantel La Tinaja",
            dataMunicipio: "Querétaro", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 11 Plantel La Tinaja"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 12 Plantel Paso de Mata"
            , dataMunicipio: "Querétaro", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 12 Plantel Paso de Mata"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 6 Corregidora"
            , dataMunicipio: "Corregidora", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 6 Corregidora"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 7 Plantel San Juan del Río"
            , dataMunicipio: "San Juan del Río", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 7 Plantel San Juan del Río"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 8 Plantel Menchaca"
            , dataMunicipio: "Querétaro", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 8 Plantel Menchaca"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 82 Plantel Huimilpan"
            , dataMunicipio: "Huimilpan", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 82 Plantel Huimilpan"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 83 Plantel Pedro Escobedo"
            , dataMunicipio: "Pedro Escobedo", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 83 Plantel Pedro Escobedo"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 84 Plantel Pinal de Amoles"
            , dataMunicipio: "Pinal De Amoles", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 84 Plantel Pinal de Amoles"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 85 Plantel Peñamiller"
            , dataMunicipio: "Peñamiller", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 85 Plantel Peñamiller"
        },
        {
            value: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 9 Plantel Montenegro"
            , dataMunicipio: "Querétaro", label: "Colegio de Estudios Científicos y Tecnológicos del Estado de Querétaro Num. 9 Plantel Montenegro"
        },
        {
            value: "Colegio de Estudios Cientificos y Tecnológicos del Estado de Querétaro Plantel Querétaro"
            , dataMunicipio: "Querétaro", label: "Colegio de Estudios Cientificos y Tecnológicos del Estado de Querétaro Plantel Querétaro"
        },
        { value: "Colegio de Estudios Profesionales Lausanne", dataMunicipio: "Querétaro", label: "Colegio de Estudios Profesionales Lausanne" },
        { value: "Colegio del Tepeyac, Querétaro", dataMunicipio: "Querétaro", label: "Colegio del Tepeyac, Querétaro" },
        { value: "Colegio Diego Olvera Estrada", dataMunicipio: "Querétaro", label: "Colegio Diego Olvera Estrada" },
        { value: "Colegio Educación y Patria", dataMunicipio: "Querétaro", label: "Colegio Educación y Patria" },
        { value: "Colegio Fontanar", dataMunicipio: "Corregidora", label: "Colegio Fontanar" },
        { value: "Colegio Fray Luis de León", dataMunicipio: "Querétaro", label: "Colegio Fray Luis de León" },

        { value: "Colegio General Regules", dataMunicipio: "Querétaro", label: "Colegio General Regules" },
        { value: "Colegio Gran Bretaña", dataMunicipio: "Querétaro", label: "Colegio Gran Bretaña" },
        { value: "Colegio Helen Parkhurst", dataMunicipio: "Querétaro", label: "Colegio Helen Parkhurst" },
        { value: "Colegio Holandés de Querétaro", dataMunicipio: "Querétaro", label: "Colegio Holandés de Querétaro" },
        { value: "Colegio Internacional de Estudios Virtuales", dataMunicipio: "Querétaro", label: "Colegio Internacional de Estudios Virtuales" },
        { value: "Colegio Internacional de Querétaro", dataMunicipio: "Querétaro", label: "Colegio Internacional de Querétaro" },
        { value: "Colegio La Salle San Juan del Río", dataMunicipio: "San Juan del Río", label: "Colegio La Salle San Juan del Río" },
        { value: "Colegio Lafayette de Querétaro, A. C.", dataMunicipio: "Querétaro", label: "Colegio Lafayette de Querétaro, A. C." },
        { value: "Colegio Marcelina", dataMunicipio: "Querétaro", label: "Colegio Marcelina" },
        { value: "Colegio Masía de Querétaro", dataMunicipio: "Querétaro", label: "Colegio Masía de Querétaro" },

        { value: "Colegio Militarizado Nuevo México Campus Querétaro", dataMunicipio: "Corregidora", label: "Colegio Militarizado Nuevo México Campus Querétaro" },
        { value: "Colegio Montpellier", dataMunicipio: "Querétaro", label: "Colegio Montpellier" },
        { value: "Colegio Motolínia de Sistema Educativo Valladolid", dataMunicipio: "Querétaro", label: "Colegio Motolínia de Sistema Educativo Valladolid" },
        { value: "Colegio Nacional de Danza Contemporánea", dataMunicipio: "Querétaro", label: "Colegio Nacional de Danza Contemporánea" },
        {
            value: "Colegio Nacional de Educación Profesional Técnica 'Amealco'"
            , dataMunicipio: "Amealco de Bonfil", label: "Colegio Nacional de Educación Profesional Técnica 'Amealco'"
        },
        {
            value: "Colegio Nacional de Educación Profesional Técnica Num. 41 'Querétaro'"
            , dataMunicipio: "Querétaro", label: "Colegio Nacional de Educación Profesional Técnica Num. 41 'Querétaro'"
        },
        {
            value: "Colegio Nacional de Educación Profesional Técnica Num. 42 'San Juan del Río'"
            , dataMunicipio: "San Juan del Río", label: "Colegio Nacional de Educación Profesional Técnica Num. 42 'San Juan del Río'"
        },
        { value: "Colegio Nueva España", dataMunicipio: "Querétaro", label: "Colegio Nueva España" },
        { value: "Colegio Real de Querenda Bachillerato", dataMunicipio: "Tequisquiapan", label: "Colegio Real de Querenda Bachillerato" },
        { value: "Colegio South Hill de Querétaro, S.C.", dataMunicipio: "Corregidora", label: "Colegio South Hill de Querétaro, S.C." },
        { value: "Colegio Suizo de México", dataMunicipio: "Querétaro", label: "Colegio Suizo de México" },
        { value: "Colegio Sunhills Valley", dataMunicipio: "Querétaro", label: "Colegio Sunhills Valley" },
        { value: "Colegio Universitario de Humanidades (CUDH)", dataMunicipio: "Querétaro", label: "Colegio Universitario de Humanidades (CUDH)" },
        { value: "Colegio Wexford", dataMunicipio: "Corregidora", label: "Colegio Wexford" },
        {
            value: "Conjunto Educativo Social Comercial Administrativo, A.C."
            , dataMunicipio: "Querétaro", label: "Conjunto Educativo Social Comercial Administrativo, A.C."
        },
        {
            value: "Conjunto Educativo Social Comercial Administrativo"
            , dataMunicipio: "Pedro Escobedo", label: "Conjunto Educativo Social Comercial Administrativo"
        },
        { value: "Coordinación de Preparatoria Abierta", dataMunicipio: "Querétaro", label: "Coordinación de Preparatoria Abierta" },
        { value: "Corregidora", dataMunicipio: "Querétaro", label: "Corregidora" },
        { value: "Educativa Metropolitana", dataMunicipio: "Querétaro", label: "Educativa Metropolitana" },
        { value: "EMSAD Num. 3 Conca", dataMunicipio: "Arroyo Seco", label: "EMSAD Num. 3 Conca" },
        { value: "EMSAD Num. 6 El Coyote", dataMunicipio: "Colón", label: "EMSAD Num. 6 El Coyote" },
        { value: "EMSAD Num. 7 Higuerillas", dataMunicipio: "Cadereyta de Montes", label: "EMSAD Num. 7 Higuerillas" },
        { value: "EMSAD Num. 8 Santa Águeda", dataMunicipio: "Pinal de Amoles", label: "EMSAD Num. 8 Santa Águeda" },
        { value: "EMSAD Num. 11 Peña Colorada", dataMunicipio: "Colón", label: "EMSAD Num. 11 Peña Colorada" },
        { value: "EMSAD Num. 12 Camargo", dataMunicipio: "Peñamiller", label: "EMSAD Num. 12 Camargo" },
        { value: "EMSAD Num. 13 San Pedro Escanela", dataMunicipio: "Pinal de Amoles", label: "EMSAD Num. 13 San Pedro Escanela" },
        { value: "EMSAD Num. 14 Tres Lagunas", dataMunicipio: "Landa de Matamoros", label: "EMSAD Num. 14 Tres Lagunas" },
        { value: "EMSAD Num. 18 Tilaco", dataMunicipio: "Landa de Matamoros", label: "EMSAD Num. 18 Tilaco" },
        { value: "EMSAD Num. 19 San Miguel Palmas", dataMunicipio: "Peñamiller", label: "EMSAD Num. 19 San Miguel Palmas" },
        { value: "EMSAD Num. 20 Landa de Matamoros", dataMunicipio: "Landa de Matamoros", label: "EMSAD Num. 20 Landa de Matamoros" },
        { value: "EMSAD Num. 22 Peña Blanca", dataMunicipio: "Peñamiller", label: "EMSAD Num. 22 Peña Blanca" },
        { value: "EMSAD Num. 23 Sombrerete", dataMunicipio: "Cadereyta de Montes", label: "EMSAD Num. 23 Sombrerete" },
        { value: "EMSAD Num. 24 Casa Blanca", dataMunicipio: "Tolimán", label: "EMSAD Num. 24 Casa Blanca" },
        { value: "EMSAD Num. 25 El Rincón", dataMunicipio: "Cadereyta de Montes", label: "EMSAD Num. 25 El Rincón" },
        { value: "EMSAD Num. 26 Tancoyol", dataMunicipio: "Jalpan de Serra", label: "EMSAD Num. 26 Tancoyol" },
        { value: "EMSAD Num. 27 Agua Fría", dataMunicipio: "Peñamiller", label: "EMSAD Num. 27 Agua Fría" },
        { value: "EMSAD Num. 28 Bellavista del Río", dataMunicipio: "Cadereyta de Montes", label: "EMSAD Num. 28 Bellavista del Río" },
        { value: "EMSAD Num. 30 San Miguel Tlaxcaltepec", dataMunicipio: "Amealco de Bonfil", label: "EMSAD Num. 30 San Miguel Tlaxcaltepec" },
        { value: "EMSAD Num. 31 Valle Verde", dataMunicipio: "Jalpan de Serra", label: "EMSAD Num. 31 Valle Verde" },
        { value: "EMSAD Num. 32 Santa María Álamos", dataMunicipio: "San Joaquín", label: "EMSAD Num. 32 Santa María Álamos" },
        { value: "EMSAD Num. 33 Buenavista", dataMunicipio: "Huimilpan", label: "EMSAD Num. 33 Buenavista" },
        { value: "EMSAD Num. 34 Escolásticas", dataMunicipio: "Pedro Escobedo", label: "EMSAD Num. 34 Escolásticas" },
        { value: "Escuela de Asistentes Educativos Chiquitines, A. C.", dataMunicipio: "Querétaro", label: "Escuela de Asistentes Educativos Chiquitines, A. C." },
        {
            value: "Escuela de Bachilleres de la UAQ, Modalidad Mixta y no Escolarizada"
            , dataMunicipio: "Querétaro", label: "Escuela de Bachilleres de la UAQ, Modalidad Mixta y no Escolarizada"
        },
        { value: "Escuela de Bachilleres de la UAQ, Plantel Amazcala", dataMunicipio: "El Marqués", label: "Escuela de Bachilleres de la UAQ, Plantel Amazcala" },
        {
            value: "Escuela de Bachilleres de la UAQ, Plantel Amealco"
            , dataMunicipio: "Amealco de Bonfil", label: "Escuela de Bachilleres de la UAQ, Plantel Amealco"
        },
        {
            value: "Escuela de Bachilleres de la UAQ, Plantel Bicentenario"
            , dataMunicipio: "Querétaro", label: "Escuela de Bachilleres de la UAQ, Plantel Bicentenario"
        },
        { value: "Escuela de Bachilleres de la UAQ, Plantel Colón", dataMunicipio: "Colón", label: "Escuela de Bachilleres de la UAQ, Plantel Colón" },
        { value: "Escuela de Bachilleres de la UAQ, Plantel Conca", dataMunicipio: "Arroyo Seco", label: "Escuela de Bachilleres de la UAQ, Plantel Conca" },
        {
            value: "Escuela de Bachilleres de la UAQ, Plantel Corregidora"
            , dataMunicipio: "Corregidora", label: "Escuela de Bachilleres de la UAQ, Plantel Corregidora"
        },
        { value: "Escuela de Bachilleres de la UAQ, Plantel Huimilpan", dataMunicipio: "Huimilpan", label: "Escuela de Bachilleres de la UAQ, Plantel Huimilpan" },

        {
            value: "Escuela de Bachilleres de la UAQ, Plantel Jalpan"
            , dataMunicipio: "Jalpan de Serra", label: "Escuela de Bachilleres de la UAQ, Plantel Jalpan"
        },
        {
            value: "Escuela de Bachilleres de la UAQ, Plantel Landa de Matamoros"
            , dataMunicipio: "Landa De Matamoros", label: "Escuela de Bachilleres de la UAQ, Plantel Landa de Matamoros"
        },
        { value: "Escuela de Bachilleres de la UAQ, Plantel Norte", dataMunicipio: "Querétaro", label: "Escuela de Bachilleres de la UAQ, Plantel Norte" },
        {
            value: "Escuela de Bachilleres de la UAQ, Plantel Pedro Escobedo"
            , dataMunicipio: "Pedro Escobedo", label: "Escuela de Bachilleres de la UAQ, Plantel Pedro Escobedo"
        },
        {
            value: "Escuela de Bachilleres de la UAQ, Plantel Pinal de Amoles"
            , dataMunicipio: "Pinal De Amoles", label: "Escuela de Bachilleres de la UAQ, Plantel Pinal de Amoles"
        },
        {
            value: "Escuela de Bachilleres de la UAQ, Plantel San Juan del Río"
            , dataMunicipio: "San Juan del Río", label: "Escuela de Bachilleres de la UAQ, Plantel San Juan del Río"
        },
        { value: "Escuela de Bachilleres de la UAQ, Plantel Sur", dataMunicipio: "Querétaro", label: "Escuela de Bachilleres de la UAQ, Plantel Sur" },
        { value: "Escuela Preparatoria del Instituto Plancarte", dataMunicipio: "Querétaro", label: "Escuela Preparatoria del Instituto Plancarte" },
        { value: "Escuela Preparatoria Leonardo de Vinci", dataMunicipio: "Querétaro", label: "Escuela Preparatoria Leonardo de Vinci" },
        { value: "High School John Dewey", dataMunicipio: "Corregidora", label: "High School John Dewey" },

        { value: "Instituto Bilingüe Victoria, A. C.", dataMunicipio: "Tequisquiapan", label: "Instituto Bilingüe Victoria, A. C." },
        { value: "Instituto Cambridge", dataMunicipio: "Querétaro", label: "Instituto Cambridge" },
        { value: "Instituto Champagnat", dataMunicipio: "Querétaro", label: "Instituto Champagnat" },
        { value: "Instituto Comercial Imec", dataMunicipio: "Querétaro", label: "Instituto Comercial Imec" },
        { value: "Instituto La Providencia", dataMunicipio: "Corregidora", label: "Instituto La Providencia" },
        {
            value: "Instituto de Estudios Sociales y Administrativos de Querétaro"
            , dataMunicipio: "Querétaro", label: "Instituto de Estudios Sociales y Administrativos de Querétaro"
        },
        { value: "Instituto de la Juventud José Martí", dataMunicipio: "Querétaro", label: "Instituto de la Juventud José Martí" },
        { value: "Instituto de Liderazgo Idel", dataMunicipio: "Querétaro", label: "Instituto de Liderazgo Idel" },
        { value: "Instituto Ex Novo", dataMunicipio: "Querétaro", label: "Instituto Ex Novo" },
        { value: "Instituto La Paz de Querétaro, A.C.", dataMunicipio: "Querétaro", label: "Instituto La Paz de Querétaro, A.C." },
        { value: "Instituto Marciano Tinajero y Estrada", dataMunicipio: "Querétaro", label: "Instituto Marciano Tinajero y Estrada" },

        { value: "Instituto Oriente Querétaro", dataMunicipio: "Corregidora", label: "Instituto Oriente Querétaro" },
        { value: "Instituto Paulo Freire Preparatoria", dataMunicipio: "Querétaro", label: "Instituto Paulo Freire Preparatoria" },
        { value: "Instituto Plancarte San Juan del Río", dataMunicipio: "San Juan del Río", label: "Instituto Plancarte San Juan del Río" },
        {
            value: "Instituto Preuniversitario del Centro/body> de México Campus Querétaro"
            , dataMunicipio: "Querétaro", label: "Instituto Preuniversitario del Centro de México Campus Querétaro"
        },
        {
            value: "Instituto Preuniversitario del Centro de México Campus San Juan del Río"
            , dataMunicipio: "San Juan del Río", label: "Instituto Preuniversitario del Centro de México Campus San Juan del Río"
        },
        { value: "Instituto Profesional de Informática y Computación", dataMunicipio: "Querétaro", label: "Instituto Profesional de Informática y Computación" },
        { value: "Instituto Querétano", dataMunicipio: "Querétaro", label: "Instituto Querétano" },
        { value: "Instituto Querétano de Herramentales", dataMunicipio: "Querétaro", label: "Instituto Querétano de Herramentales" },
        { value: "Instituto Rembrandt", dataMunicipio: "Querétaro", label: "Instituto Rembrandt" },
        { value: "Instituto Renacimiento Preparatoria", dataMunicipio: "Querétaro", label: "Instituto Renacimiento Preparatoria" },

        { value: "Instituto Santiago (Preparatoria)", dataMunicipio: "Querétaro", label: "Instituto Santiago (Preparatoria)" },
        {
            value: "Instituto Social Comercial en Contaduría Administrativa A.C."
            , dataMunicipio: "Ezequiel Montes", label: "Instituto Social Comercial en Contaduría Administrativa A.C."
        },
        { value: "Instituto Social Educativo Comercial Administrativo", dataMunicipio: "Querétaro", label: "Instituto Social Educativo Comercial Administrativo" },
        { value: "Instituto Sovany", dataMunicipio: "Tequisquiapan", label: "Instituto Sovany" },
        { value: "Instituto Tecnológico Anglo Mexicano", dataMunicipio: "Querétaro", label: "Instituto Tecnológico Anglo Mexicano" },
        { value: "Instituto Thomas Jefferson", dataMunicipio: "Querétaro", label: "Instituto Thomas Jefferson" },
        {
            value: "Instituto Universitario de Desarrollo Humano e Innovación Profesional"
            , dataMunicipio: "Corregidora", label: "Instituto Universitario de Desarrollo Humano e Innovación Profesional"
        },
        { value: "ITESM Campus Querétaro", dataMunicipio: "Querétaro", label: "ITESM Campus Querétaro" },
        { value: "John F. Kennedy", dataMunicipio: "Querétaro", label: "John F. Kennedy" },

        { value: "Liceo de Querétaro", dataMunicipio: "Querétaro", label: "Liceo de Querétaro" },
        { value: "Lic. José Guadalupe Ramírez Álvarez", dataMunicipio: "Querétaro", label: "Lic. José Guadalupe Ramírez Álvarez" },
        { value: "Liceo Corregidora", dataMunicipio: "Corregidora", label: "Liceo Corregidora" },
        { value: "Liceo Patrick Henry Preparatoria", dataMunicipio: "El Marqués", label: "Liceo Patrick Henry Preparatoria" },
        {
            value: "Lycée Français International Jules Verne Sección Preparatoria"
            , dataMunicipio: "El Marqués", label: "Lycée Français International Jules Verne Sección Preparatoria"
        },
        { value: "MH Institución Educativa", dataMunicipio: "Querétaro", label: "MH Institución Educativa" },
        { value: "New Port High School", dataMunicipio: "Querétaro", label: "New Port High School" },
        { value: "Plantel Conalep Aeronáutico", dataMunicipio: "El Marqués", label: "Plantel Conalep Aeronáutico" },
        { value: "Plantel Conalep Automotriz José Vasconcelos", dataMunicipio: "Querétaro", label: "Plantel Conalep Automotriz José Vasconcelos" },
        { value: "Prepa Anáhuac Querétaro", dataMunicipio: "Querétaro", label: "Prepa Anáhuac Querétaro" },

        { value: "Prepa Balmoral Escocés", dataMunicipio: "Querétaro", label: "Prepa Balmoral Escocés" },
        { value: "Prepa Cav", dataMunicipio: "Corregidora", label: "Prepa Cav" },
        { value: "Prepa Ceickor", dataMunicipio: "Colón", label: "Prepa Ceickor" },
        { value: "Prepa Idai", dataMunicipio: "Querétaro", label: "Prepa Idai" },
        { value: "Prepa Plenus", dataMunicipio: "Corregidora", label: "Prepa Plenus" },
        { value: "Preparatoria Centro Escolar Cadereyta", dataMunicipio: "Cadereyta de Montes", label: "Preparatoria Centro Escolar Cadereyta" },
        { value: "Preparatoria Cervantes", dataMunicipio: "Querétaro", label: "Preparatoria Cervantes" },
        { value: "Preparatoria Cesba", dataMunicipio: "Querétaro", label: "Preparatoria Cesba" },
        { value: "Preparatoria Conín", dataMunicipio: "Querétaro", label: "Preparatoria Conín" },
        { value: "Preparatoria Cuauhtémoc Querétaro", dataMunicipio: "Querétaro", label: "Preparatoria Cuauhtémoc Querétaro" },

        { value: "Preparatoria de Negocios", dataMunicipio: "Querétaro", label: "Preparatoria de Negocios" },
        { value: "Preparatoria del Instituto Asunción de Querétaro", dataMunicipio: "Querétaro", label: "Preparatoria del Instituto Asunción de Querétaro" },
        { value: "Preparatoria Emprende Innova", dataMunicipio: "Corregidora", label: "Preparatoria Emprende Innova" },
        { value: "Preparatoria Intercultural San Patricio", dataMunicipio: "Querétaro", label: "Preparatoria Intercultural San Patricio" },
        { value: "Preparatoria Iteca", dataMunicipio: "Querétaro", label: "Preparatoria Iteca" },
        { value: "Preparatoria La Cima", dataMunicipio: "Querétaro", label: "Preparatoria La Cima" },
        { value: "Preparatoria Nuevo Horizonte", dataMunicipio: "Querétaro", label: "Preparatoria Nuevo Horizonte" },
        { value: "Preparatoria Summerhill", dataMunicipio: "Querétaro", label: "Preparatoria Summerhill" },
        {
            value: "Preparatoria Universidad Marista de Querétaro, Campus San Juan del Río"
            , dataMunicipio: "San Juan del Río", label: "Preparatoria Universidad Marista de Querétaro, Campus San Juan del Río"
        },
        { value: "Preparatorias Universidad Marista de Querétaro", dataMunicipio: "Querétaro", label: "Preparatorias Universidad Marista de Querétaro" },

        { value: "Santiago Galás", dataMunicipio: "Tequisquiapan", label: "Santiago Galás" },
        { value: "Telebachillerato Comunitario Agua Fría", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario Agua Fría" },
        { value: "Telebachillerato Comunitario El Aguacate", dataMunicipio: "Cadereyta de Montes", label: "Telebachillerato Comunitario El Aguacate" },
        { value: "Telebachillerato Comunitario El Lobo", dataMunicipio: "Landa de Matamoros", label: "Telebachillerato Comunitario El Lobo" },
        { value: "Telebachillerato Comunitario El Platano", dataMunicipio: "San Joaquín", label: "Telebachillerato Comunitario El Platano" },
        { value: "Telebachillerato Comunitario La Carbonera", dataMunicipio: "Colón", label: "Telebachillerato Comunitario La Carbonera" },
        { value: "Telebachillerato Comunitario La Florida", dataMunicipio: "Arroyo Seco", label: "Telebachillerato Comunitario La Florida" },
        { value: "Telebachillerato Comunitario La Fuente", dataMunicipio: "Tequisquiapan", label: "Telebachillerato Comunitario La Fuente" },
        { value: "Telebachillerato Comunitario La Monja", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario La Monja" },
        { value: "Telebachillerato Comunitario La Plazuela", dataMunicipio: "Peñamiller", label: "Telebachillerato Comunitario La Plazuela" },

        { value: "Telebachillerato Comunitario La Solana", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario La Solana" },
        { value: "Telebachillerato Comunitario La Versolilla", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario La Versolilla" },
        { value: "Telebachillerato Comunitario Laguna de Servín", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario Laguna de Servín" },
        { value: "Telebachillerato Comunitario Laguna de Vaquerías", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario Laguna de Vaquerías" },
        { value: "Telebachillerato Comunitario Los Juárez", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario Los Juárez" },
        { value: "Telebachillerato Comunitario Maconí", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario Maconí" },
        { value: "Telebachillerato Comunitario Mesa de Ramírez", dataMunicipio: "Tolimán", label: "Telebachillerato Comunitario Mesa de Ramírez" },
        { value: "Telebachillerato Comunitario Neblinas", dataMunicipio: "Landa de Matamoros", label: "Telebachillerato Comunitario Neblinas" },
        { value: "Telebachillerato Comunitario Paniagua", dataMunicipio: "Huimilpan", label: "Telebachillerato Comunitario Paniagua" },
        { value: "Telebachillerato Comunitario Pathe", dataMunicipio: "Cadereyta de Montes", label: "Telebachillerato Comunitario Pathe" },

        { value: "Telebachillerato Comunitario Puerto de la Luz", dataMunicipio: "Cadereyta de Montes", label: "Telebachillerato Comunitario Puerto de la Luz" },
        { value: "Telebachillerato Comunitario Quiotillos", dataMunicipio: "Amealco de Bonfil", label: "Telebachillerato Comunitario Quiotillos" },
        { value: "Telebachillerato Comunitario Rancho Nuevo", dataMunicipio: "Tolimán", label: "Telebachillerato Comunitario Rancho Nuevo" },
        { value: "Telebachillerato Comunitario San Ignacio", dataMunicipio: "Huimilpan", label: "Telebachillerato Comunitario San Ignacio" },
        { value: "Telebachillerato Comunitario San Pedro Viejo", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario San Pedro Viejo" },
        { value: "Telebachillerato Comunitario Santa Inés", dataMunicipio: "Landa de Matamoros", label: "Telebachillerato Comunitario Santa Inés" },
        { value: "Telebachillerato Comunitario Santa Lucía", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario Santa Lucía" },
        {
            value: "Telebachillerato Comunitario Santa María de los Cocos"
            , dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario Santa María de los Cocos"
        },
        { value: "Telebachillerato Comunitario Sauz de Guadalupe", dataMunicipio: "Querétaro", label: "Telebachillerato Comunitario Sauz de Guadalupe" },
        { value: "Telebachillerato Comunitario Yerbabuena", dataMunicipio: "Pinal de Amoles", label: "Telebachillerato Comunitario Yerbabuena" },

        { value: "Universidad Alfred Nobel Bachillerato", dataMunicipio: "Querétaro", label: "Universidad Alfred Nobel Bachillerato" },
        { value: "Universidad Mondragón México", dataMunicipio: "El Marqués", label: "Universidad Mondragón México" },
        { value: "Universidad Tec Milenio", dataMunicipio: "Corregidora", label: "Universidad Tec Milenio" },
        {
            value: "Universidad Tecnologica de Mexico Bachillerato, Campus Queretaro"
            , dataMunicipio: "Querétaro", label: "Universidad Tecnologica de Mexico Bachillerato, Campus Queretaro"
        },
        { value: "Vanguardia Educativa de Mexico", dataMunicipio: "Corregidora", label: "Vanguardia Educativa de Mexico" },
        { value: "Quiotillos 22ETK0027H", dataMunicipio: "Amealco de Bonfil", label: "Quiotillos 22ETK0027H" },
        { value: "Laguna De Servin 22ETK0028G", dataMunicipio: "Amealco de Bonfil", label: "Laguna De Servin 22ETK0028G" },
        { value: "Santa Maria De Los Cocos 22ETK0025J", dataMunicipio: "Arroyo Seco", label: "Santa Maria De Los Cocos 22ETK0025J" },
        { value: "La Florida 22ETK0026I", dataMunicipio: "Arroyo Seco", label: "La Florida 22ETK0026I" },
        { value: "El Aguacate 22ETK0006V", dataMunicipio: "Cadereyta de Montes", label: "El Aguacate 22ETK0006V" },
        { value: "Puerto de la Luz 22ETK0008T", dataMunicipio: "Cadereyta de Montes", label: "Puerto de la Luz 22ETK0008T " },
        { value: "Pathe 22ETK0009S", dataMunicipio: "Cadereyta de Montes", label: "Pathe 22ETK0009S" },
        { value: "Maconi 22ETK0023L", dataMunicipio: "Cadereyta de Montes", label: "Maconi 22ETK0023L" },
        { value: "Los Juarez 22ETK0024K", dataMunicipio: "Cadereyta de Montes", label: "Los Juarez 22ETK0024K" },
        { value: "La Carbonera 22ETK0007U", dataMunicipio: "Colón", label: "La Carbonera 22ETK0007U" },
        { value: "Paniagua 22ETK0017A", dataMunicipio: "Huimilpan", label: "Paniagua 22ETK0017A" },
        { value: "San Ignacio 22ETK0018Z", dataMunicipio: "Huimilpan", label: "San Ignacio 22ETK0018Z" },
        { value: "Agua Fria 22ETK0013E", dataMunicipio: "Jalpan de Serra", label: "Agua Fria 22ETK0013E" },
        { value: "Yerbabuena 22ETK0014D", dataMunicipio: "Jalpan de Serra", label: "Yerbabuena 22ETK0014D" },
        { value: "Neblinas 22ETK0012F", dataMunicipio: "Landa de Matamoros", label: "Neblinas 22ETK0012F" },
        { value: "Santa Ines 22ETK0015C", dataMunicipio: "Landa de Matamoros", label: "Santa Ines 22ETK0015C" },
        { value: "El Lobo 22ETK0016B", dataMunicipio: "Landa de Matamoros", label: "El Lobo 22ETK0016B" },
        { value: "La Plazuela 22ETK0021M", dataMunicipio: "Peñamiller", label: "La Plazuela 22ETK0021M" },
        { value: "Sauz De Guadalupe 22ETK0021N", dataMunicipio: "Pinal de Amoles", label: "Sauz De Guadalupe 22ETK0021N" },
        { value: "San Pedro Viejo 22ETK0022M", dataMunicipio: "Pinal de Amoles", label: "San Pedro Viejo 22ETK0022M" },
        { value: "La Versolilla 22ETK0022N", dataMunicipio: "Querétaro", label: "La Versolilla 22ETK0022N" },
        { value: "La Solana 22ETK0022O", dataMunicipio: "Querétaro", label: "La Solana 22ETK0022O" },
        { value: "La Monja 22ETK0020K", dataMunicipio: "San Joaquín", label: "La Monja 22ETK0020K" },
        { value: "El Plátano 22ETK0020L", dataMunicipio: "San Joaquín", label: "El Plátano 22ETK0020L" },
        { value: "Laguna De Vaquerias 22ETK0020M", dataMunicipio: "San Juan Del Río", label: "Laguna De Vaquerias 22ETK0020M" },
        { value: "Santa Lucia 22ETK0020N", dataMunicipio: "San Juan Del Río", label: "Santa Lucia 22ETK0020N" },
        { value: "La Fuente 22ETK0020O", dataMunicipio: "Tequisquiapan", label: "La Fuente 22ETK0020O" },
        { value: "Las Mesas De Ramirez 22ETK0020P", dataMunicipio: "Tolimán", label: "Las Mesas De Ramirez 22ETK0020P" },
        { value: "Rancho Nuevo 22ETK0019Z", dataMunicipio: "Tolimán", label: "Rancho Nuevo 22ETK0019Z" },
        { value: "Otro", label: "Otro" },
    ];

    const bachilleratosMunicipio = bachilleratos.filter(
        (b) => b.dataMunicipio === municipio
    );

const handleSubmit = async (e) => {
    e.preventDefault();

    const nuevosErrores = { 
        contrasenia: '', 
        curp: '', 
        telefono: '', 
        correo: '', 
        correo_tutor: ''
    }; 

    let hayErrores = false; 

    if (contrasenia !== confcontrasenia) {
        nuevosErrores.contrasenia = "La contraseña no coincide."; 
        hayErrores = true; 
    } else if (contrasenia.length < 8) {
        nuevosErrores.contrasenia = "La contraseña debe tener al menos 8 caracteres."; 
        hayErrores = true; 
    } else if (!/[A-Z]/.test(contrasenia)) {
        nuevosErrores.contrasenia = "La contraseña debe tener una letra mayúscula."; 
        hayErrores = true; 
    } else if (!/[a-z]/.test(contrasenia)) {
        nuevosErrores.contrasenia = "La contraseña debe tener una letra minúscula.";
        hayErrores = true; 
    } else if (!/[0-9]/.test(contrasenia)) {
        nuevosErrores.contrasenia = "La contraseña debe tener un número."
        hayErrores = true;
    } else if (!/[\W_]/.test(contrasenia)) {
        nuevosErrores.contrasenia = "La contraseña debe tener un carácter especial."; 
        hayErrores = true; 
    }

    if (telefono.length < 10) {
        nuevosErrores.telefono = "El teléfono debe tener al menos 10 dígitos."; 
        hayErrores = true; 
    } else if (telefono.length > 14) {
        nuevosErrores.telefono = "El teléfono no debe exceder 14 dígitos."; 
        hayErrores = true; 
    }

    //Validación de correo. 
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(correo)) {
        nuevosErrores.correo = "El correo no es válido."; 
        hayErrores = true;  
    }

    const curpRegex = /^[A-Z]{4}[0-9]{6}[HM][A-Z]{5}[0-9A-Z]{2}$/;
    if (!curpRegex.test(curp)) {
        nuevosErrores.curp = "La CURP no es válido.";  
        hayErrores = true; 
    }

    //Validación del correo del tutor. 
    if (correo_tutor) { 
        if (!emailRegex.test(correo_tutor)) { 
            nuevosErrores.correo_tutor = "El correo del tutor no es válido."; 
            hayErrores = true; 
        }
    }

    setErrores(nuevosErrores); 

    if(!hayErrores) {
        const estadoFinal = seleccionEstud === 'si' ? 'Querétaro' : estado; 

        const datosRegistro = { 
            nombre, 
            appa, 
            apma, 
            correo, 
            telefono, 
            contrasenia, 
            fecha_nacimiento, 
            tipo_usuario: 1,
            curp: curp,
            correo_tutor: correo_tutor, 
            estado: estadoFinal, 
            municipio: municipio, 
            bachillerato: bachillerato, 
            matricula: matricula, 
            institucion: institucion
        }



     const API_URL = process.env.REACT_APP_API_URL || '/api';

        fetch(`${API_URL}/auth/registro`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(datosRegistro),
})
        .then(response => { 
            if(!response.ok) { 
                return response.json().then(data => { 
                    throw new Error(data.error || 'Error al registrar'); 
                }); 
            }
            return response.json(); 
        })
        .then(data => { 
            if (data.requiere_verificacion) { 
                setMostrarVerificacion(true); 
                setCorreoVerificacion(correo); 
            } else { 
            Swal.fire({
                title: 'Registro exitoso.', 
                icon: 'success',
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#242b57',
                customClass: { popup: 'popupbonito' }
            }).then(() => {
                navigate('/signin');
            }); 
        }
        })
        .catch(error => {
            setMensaje(error.message);
            console.error('Error:', error); 
            Swal.fire({
                title: 'Error', 
                text: error.message || 'Ha ocurrido un error al registrar', 
                icon: 'error', 
                confirmButtonColor: '#242b57',
                customClass: { popup: 'popupbonito' }
            }); 
            setErrores(prev => ({ 
                ...prev, 
                correo: error.message.includes('correo') ? error.message : prev.correo 
            })); 
        }); 
    }
};



const handleGoToLogin = () => { 
    navigate('/signin'); 
}

const validarContrasenia = (contrasenia, confirmacion) => { 
    if (!contrasenia) return '';
    
    if (confirmacion && contrasenia !== confirmacion) {
        return "Las contraseñas no coinciden.";
    }
    if (contrasenia.length < 8) {
        return "La contraseña debe tener al menos 8 caracteres.";
    }
    if (!/[A-Z]/.test(contrasenia)) {
        return "La contraseña debe tener una letra mayúscula.";
    }
    if (!/[a-z]/.test(contrasenia)) {
        return "La contraseña debe tener una letra minúscula.";
    }
    if (!/[0-9]/.test(contrasenia)) {
        return "La contraseña debe tener un número.";
    }
    if (!/[\W_]/.test(contrasenia)) {
        return "La contraseña debe tener un carácter especial.";
    }
    return '';
}; 

const validarCurp = (curp) => { 
    if (!curp) return ''; 

    const curpRegex = /^[A-Z]{4}[0-9]{6}[HM][A-Z]{5}[0-9A-Z]{2}$/;
    if (!curpRegex.test(curp)) { 
        return "La CURP no es válida."; 
    }
    return ''; 
}; 

const validarEmail = (email) => { 
    if (!email) return ''; 
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(email)) {
        return "El correo no es válido.";
    }
    return ''; 
}; 

const handleChangeContrasenia = (e) => { 
    const valor = e.target.value; 
    setContrasenia(valor); 
    setErrores(prev => ({ 
        ...prev, 
        contrasenia : validarContrasenia(valor, confcontrasenia)
    })); 
}

const handleChangeConfContrasenia = (e) => { 
    const valor = e.target.value; 
    setConfContrasenia(valor); 
    setErrores(prev => ({ 
        ...prev, 
        contrasenia: validarContrasenia(contrasenia, valor) 
    })); 
}; 

const handleChangeCurp = (e) => {
    const valor = e.target.value;
    setCurp(valor);
    setErrores(prev => ({
        ...prev,
        curp: validarCurp(valor)
    }));
}; 

const handleChangeCorreo = (e) => { 
    const valor = e.target.value; 
    setCorreo(valor); 
    setErrores(prev => ({
        ...prev, 
        correo: validarEmail(valor)
    })); 
};

const handleChangeCorreoTutor = async (e) => {
    const valor = e.target.value;
    setCorreoTutor(valor); 

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    
    if (valor && !emailRegex.test(valor)) { 
        setErrores(prev => ({ 
            ...prev, 
            correo_tutor: "El correo del tutor no es válido."
        }));
    } else {
        setErrores(prev => ({ 
            ...prev, 
            correo_tutor: ""
        }));
    }
};

const handleSeleccionChange = (value) => { 
    setSeleccionEstud(value); 
    if (value === 'si') { 
        setEstado('Querétaro'); 
        setInstitucion('');
    } else if (value === 'no') { 
        setMunicipio(''); 
        setBachillerato(''); 
        setMatricula(''); 
    }
};

return (
    <div className={styles.registroCuerpo}>
        <div className={styles.registroCuadro}>
            <div className={styles.headerRegistro}>
                <button className={styles.botonLogin} onClick={handleGoToLogin}>
                    <FaArrowLeft className={styles.flechaLogin} />
                </button>
                <div className={styles.spacer}></div>
            </div>

            <form onSubmit={handleSubmit} className={styles.registroForm}>
                <label className={styles.registroLabel}>
                    Apellido paterno:
                    <input type="text" className={styles.inputForm}
                        value={appa} placeholder="Ingresa tu apellido paterno" 
                        onChange={(e) => setAppa(e.target.value)} required />
                </label>

                <label className={styles.registroLabel}>
                    Apellido materno:
                    <input type="text" className={styles.inputForm}
                        value={apma} placeholder="Ingresa tu apellido materno" 
                        onChange={(e) => setApma(e.target.value)} />
                </label>

                <label className={styles.registroLabel}>
                    Nombre (s):
                    <input type="text" className={styles.inputForm}
                        value={nombre} placeholder="Ingresa tu(s) nombre(s)" 
                        onChange={(e) => setNombre(e.target.value)} required />
                </label>

                <label className={styles.registroLabel}>
                    Fecha de nacimiento:
                    <input type="date" className={styles.inputForm}
                        value={fecha_nacimiento} 
                        onChange={(e) => setFechaNacimiento(e.target.value)} required />
                </label>

                <label className={styles.registroLabel}>
                    Teléfono de contacto:
                    <PhoneInput
                        country={'mx'} 
                        value={telefono}
                        onChange={(value) => {
                            const numeroLimpio = value.replace(/\D/g, '');
                            setTelefono(numeroLimpio);
                
                            setErrores(prev => ({
                                ...prev,
                                telefono: numeroLimpio.length < 10 ? "El teléfono debe tener al menos 10 dígitos." : 
                                        (numeroLimpio.length > 14 ? "El teléfono no debe exceder 14 dígitos." : '')
                            }));
                        }}
                        inputClass={styles.inputTelefono}
                        containerClass={styles.phoneInputContainer}
                        placeholder="Ingresa un teléfono personal o del tutor"
                        preferredCountries={['mx', 'us', 'ca']}
                        enableSearch={true} 
                        searchPlaceholder="Buscar país..."
                        required
                    />
                </label>
                {errores.telefono && <p className={styles.mensajeError}>{errores.telefono}</p>}

                <label className={styles.registroLabel}>
                    Correo electrónico:
                    <input type="email" className={styles.inputForm}
                        value={correo} placeholder="Ingresa tu correo" 
                        onChange={handleChangeCorreo} required />
                </label>
                {errores.correo && <p className={styles.mensajeError}>{errores.correo}</p>}

                <div className={styles.registroCajaContrasenia}>
                    <label className={`${styles.registroLabel} ${styles.labelRequisitos}`}>
                        <p className={styles.requisitosTitulo}>La contraseña debe contar con al menos:</p>
                        <ul className={styles.listaRequisitos}>
                            <li><FaCheck className={styles.iconoCheck} /><span>8 Caracteres</span></li>
                            <li><FaCheck className={styles.iconoCheck} /><span>1 Mayúscula y 1 minúscula (A-Z, a-z)</span></li>
                            <li><FaCheck className={styles.iconoCheck} /><span>1 Número (0-9)</span></li>
                            <li><FaCheck className={styles.iconoCheck} /><span>1 Carácter especial (@$!%*?#)</span></li>
                        </ul>
                    </label>

                    <label className={`${styles.registroLabel} ${styles.campoContrasenia}`}>
                        Contraseña:
                        <input type="password" className={styles.inputForm}
                            value={contrasenia} placeholder="Ingresa contraseña segura" 
                            onChange={handleChangeContrasenia} required />
                    </label> 

                    <label className={`${styles.registroLabel} ${styles.campoContrasenia}`}>
                        Confirmar contraseña:
                        <input type="password" className={styles.inputForm}
                            value={confcontrasenia} placeholder="Ingresa de nuevo tu contraseña" 
                            onChange={handleChangeConfContrasenia} required />
                    </label>

                    {errores.contrasenia && <p className={styles.mensajeError}>{errores.contrasenia}</p>}
                </div>

                <label className={styles.registroLabel}>
                    <span className={styles.textoPrincipal}>CURP: </span>
                    <span className={styles.textAyuda}>Si no conoces tu CURP busca <a href='https://www.gob.mx/curp/' target="_blank" rel="noopener noreferrer">AQUÍ</a></span>
                    <input type="text" className={styles.inputForm} value={curp} 
                        placeholder="Ingresa tu CURP" onChange={handleChangeCurp} required /> 
                </label>
                {errores.curp && <p className={styles.mensajeError}>{errores.curp}</p>}

                <label className={styles.registroLabel}>
                    Correo del padre/tutor:
                    <input type="email" className={styles.inputForm}
                        value={correo_tutor} placeholder="Ingresa correo del padre o tutor" 
                        onChange={handleChangeCorreoTutor} required />
                </label>
                {errores.correo_tutor && <p className={styles.mensajeError}>{errores.correo_tutor}</p>}

                <div>
                    <label className={styles.registroLabel}>¿Estudiaste la preparatoria en Querétaro?</label>
                    <div className={styles.radioGroup}> 
                        <label className={styles.radioOption}>
                            <input type="radio" name="procedencia" value="si" 
                                checked={seleccionEstud === 'si'} 
                                onChange={(e) => handleSeleccionChange(e.target.value)} 
                                required />
                            <span>Sí</span>
                        </label>
                    </div>
                    <div className={styles.radioGroup}> 
                        <label className={styles.radioOption}> 
                            <input type="radio" name="procedencia" value="no" 
                                checked={seleccionEstud === 'no'} 
                                onChange={(e) => handleSeleccionChange(e.target.value)} 
                                required />
                            <span>No</span>
                        </label>
                    </div>

                    {seleccionEstud === 'si' && (
                        <div className={styles.opcionesCondicionales}>
                            <div className={styles.opcionSi}>
                                <label className={styles.registroLabel}>Municipio donde estudiaste:</label> 
                                <select className={styles.inputForm} value={municipio} 
                                    onChange={(e) => setMunicipio(e.target.value)} required>
                                    <option value="">- Selecciona un municipio -</option>
                                    {municipios.map((option, index) => (
                                        <option key={index} value={option.value}>{option.label}</option>
                                    ))}
                                </select> 
                            </div>

                            <div className={styles.opcionSi}>
                                <label className={styles.registroLabel}>Bachillerato donde estudiaste:</label>
                                <select className={styles.inputForm} value={bachillerato} 
                                    onChange={(e) => setBachillerato(e.target.value)} required>
                                    <option value="">- Selecciona un bachillerato -</option>
                                    {bachilleratosMunicipio.map((option, index) => (
                                        <option key={index} value={option.value} 
                                            data-municipio={option.dataMunicipio}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div> 

                            <div className={styles.opcionSi}>
                                <label className={styles.registroLabel}>
                                    Matrícula: 
                                    <input type="text" className={styles.inputForm} 
                                        value={matricula} placeholder="Ingresa tu matrícula" 
                                        onChange={(e) => setMatricula(e.target.value)} required />
                                </label>
                            </div> 
                        </div> 
                    )}

                    {seleccionEstud === 'no' && (
                        <div className={styles.opcionesCondicionales}>
                            <div className={styles.opcionNo}>
                                <label className={styles.registroLabel}>Estado en el que estudiaste:</label>
                                <select className={styles.inputForm} value={estado} 
                                    onChange={(e) => setEstado(e.target.value)} required>
                                    <option value="">- Selecciona un estado -</option>
                                    {estados.map((option, index) => (
                                        <option key={index} value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>

                            <div className={styles.opcionNo}>
                                <label className={styles.registroLabel}>
                                    Institución: 
                                    <input type="text" className={styles.inputForm} 
                                        value={institucion} placeholder="Ingresa tu institución" 
                                        onChange={(e) => setInstitucion(e.target.value)} required /> 
                                </label>
                            </div> 
                        </div> 
                    )}
                </div>
                
                <button type="submit" className={styles.registroBoton}>Registrarse</button>
            </form>

            {mostrarVerificacion && ( 
                <MensajeVerificacion
                    correo = {correoVerificacion}
                    onCerrar= {() => { 
                        setMostrarVerificacion(false); 
                        navigate('/signin'); 
                    }}
                />
            )}

            <h2 className={styles.registroMensaje}>{mensaje}</h2>
        </div>
    </div>
);
};

export default Register;